// GENERATED by scripts/gen-surfaces.mjs from ConsoleApp.jsx NAV_GROUPS.
// Do not edit by hand — run the generator. `--check` fails when this file and
// the sidebar disagree, which is the only thing keeping them honest.
//
// Role scope is NOT here. allowed_routes comes from my_role_scope per tenant
// at runtime, so a build-time copy would be right for one tenant and wrong for
// the rest. Apply routeAllowed() before offering a surface: otherwise the
// Guide walks someone into a page their role cannot open, and discloses it.
//
// external: true means ConsoleApp.navigate() sends it to window.open() and
// sets no hash. There is no route to land on and nothing to point at, so it
// may be offered as a link and never walked.

export const SURFACE_GROUPS = [
  "Executive Intelligence",
  "Home",
  "Discover",
  "Assess",
  "Cost",
  "Govern",
  "Enforce",
  "Prove",
  "Admin"
];

export const SURFACES = [
  {
    "id": "zerotrust",
    "label": "Zero Trust",
    "route": "zero-trust",
    "also": [],
    "group": "Executive Intelligence",
    "external": false
  },
  {
    "id": "execboard",
    "label": "Board",
    "route": "exec-board",
    "also": [],
    "group": "Executive Intelligence",
    "external": false
  },
  {
    "id": "execcaio",
    "label": "CAIO",
    "route": "exec-caio",
    "also": [],
    "group": "Executive Intelligence",
    "external": false
  },
  {
    "id": "execcio",
    "label": "CIO",
    "route": "exec-cio",
    "also": [],
    "group": "Executive Intelligence",
    "external": false
  },
  {
    "id": "execciso",
    "label": "CISO",
    "route": "exec-ciso",
    "also": [],
    "group": "Executive Intelligence",
    "external": false
  },
  {
    "id": "execcfo",
    "label": "CFO - Spend",
    "route": "exec-cfo",
    "also": [],
    "group": "Executive Intelligence",
    "external": false
  },
  {
    "id": "execcfoval",
    "label": "CFO - Value",
    "route": "exec-cfo-value",
    "also": [],
    "group": "Executive Intelligence",
    "external": false
  },
  {
    "id": "execcro",
    "label": "CRO",
    "route": "exec-cro",
    "also": [],
    "group": "Executive Intelligence",
    "external": false
  },
  {
    "id": "exposurescore",
    "label": "AI Exposure Score",
    "route": "exposure-score",
    "also": [],
    "group": "Home",
    "external": false
  },
  {
    "id": "starthere",
    "label": "Decisions",
    "route": "start-here",
    "also": [],
    "group": "Home",
    "external": false
  },
  {
    "id": "dashboard",
    "label": "Dashboard",
    "route": "dashboard",
    "also": [],
    "group": "Home",
    "external": false
  },
  {
    "id": "ainews",
    "label": "Latest AI News",
    "route": "ainews",
    "also": [],
    "group": "Home",
    "external": true
  },
  {
    "id": "inventory",
    "label": "AI Inventory",
    "route": "inventory",
    "also": [],
    "group": "Discover",
    "external": false
  },
  {
    "id": "discovery",
    "label": "AI Discovery",
    "route": "discovery",
    "also": [],
    "group": "Discover",
    "external": false
  },
  {
    "id": "agents",
    "label": "Agents & Models",
    "route": "agents",
    "also": [],
    "group": "Discover",
    "external": false
  },
  {
    "id": "nhi",
    "label": "Agent Identity (NHI)",
    "route": "nhi",
    "also": [],
    "group": "Discover",
    "external": false
  },
  {
    "id": "exposurepaths",
    "label": "Exposure Paths",
    "route": "exposure-paths",
    "also": [],
    "group": "Assess",
    "external": false
  },
  {
    "id": "govregister",
    "label": "Governance Register",
    "route": "governance-register",
    "also": [],
    "group": "Assess",
    "external": false
  },
  {
    "id": "releasecert",
    "label": "Release Certification",
    "route": "release-certification",
    "also": [],
    "group": "Assess",
    "external": false
  },
  {
    "id": "risks",
    "label": "Risk Register",
    "route": "risks",
    "also": [],
    "group": "Assess",
    "external": false
  },
  {
    "id": "owasp",
    "label": "OWASP Top 10",
    "route": "owasp-top10",
    "also": [
      "asi-coverage",
      "llm-top10"
    ],
    "group": "Assess",
    "external": false
  },
  {
    "id": "myagents",
    "label": "Your AI agents",
    "route": "my-agents",
    "also": [],
    "group": "Assess",
    "external": false
  },
  {
    "id": "behrisk",
    "label": "Behavioral Risk",
    "route": "behavioral-risk",
    "also": [],
    "group": "Assess",
    "external": false
  },
  {
    "id": "dataposture",
    "label": "Data Posture",
    "route": "dataposture",
    "also": [],
    "group": "Assess",
    "external": false
  },
  {
    "id": "vendors",
    "label": "Vendor AI Risk",
    "route": "vendors",
    "also": [],
    "group": "Assess",
    "external": false
  },
  {
    "id": "tokengov",
    "label": "Token Governance",
    "route": "token-governance",
    "also": [],
    "group": "Cost",
    "external": false
  },
  {
    "id": "copilotconsum",
    "label": "Copilot Consumption",
    "route": "copilot-consumption",
    "also": [],
    "group": "Cost",
    "external": false
  },
  {
    "id": "purposereg",
    "label": "Purpose Register",
    "route": "purpose-register",
    "also": [],
    "group": "Govern",
    "external": false
  },
  {
    "id": "archreview",
    "label": "Architecture Review",
    "route": "architecture-review",
    "also": [],
    "group": "Govern",
    "external": false
  },
  {
    "id": "supervision",
    "label": "Supervision Health",
    "route": "supervision",
    "also": [],
    "group": "Govern",
    "external": false
  },
  {
    "id": "accessreq",
    "label": "Access Requests",
    "route": "access-requests",
    "also": [],
    "group": "Govern",
    "external": false
  },
  {
    "id": "routingrules",
    "label": "Approval Routing",
    "route": "routing-rules",
    "also": [],
    "group": "Govern",
    "external": false
  },
  {
    "id": "incidents",
    "label": "Incidents",
    "route": "incidents",
    "also": [],
    "group": "Govern",
    "external": false
  },
  {
    "id": "policies",
    "label": "Policies",
    "route": "policies",
    "also": [],
    "group": "Enforce",
    "external": false
  },
  {
    "id": "datashield",
    "label": "Data Shield",
    "route": "datashield",
    "also": [],
    "group": "Enforce",
    "external": false
  },
  {
    "id": "mcpgw",
    "label": "MCP Gateway",
    "route": "mcpgw",
    "also": [],
    "group": "Enforce",
    "external": false
  },
  {
    "id": "netblock",
    "label": "Network Block List",
    "route": "network-block",
    "also": [],
    "group": "Enforce",
    "external": false
  },
  {
    "id": "purview",
    "label": "Purview",
    "route": "purview",
    "also": [],
    "group": "Enforce",
    "external": false
  },
  {
    "id": "deploy",
    "label": "Endpoint Governance",
    "route": "deploy",
    "also": [
      "deploypolicies"
    ],
    "group": "Enforce",
    "external": false
  },
  {
    "id": "coverage",
    "label": "Enforcement Coverage",
    "route": "coverage",
    "also": [],
    "group": "Enforce",
    "external": false
  },
  {
    "id": "compliance",
    "label": "Compliance & Enforcement",
    "route": "compliance",
    "also": [
      "eu-ai-act",
      "enforcement"
    ],
    "group": "Prove",
    "external": false
  },
  {
    "id": "reports",
    "label": "Reports",
    "route": "reports",
    "also": [
      "exposure"
    ],
    "group": "Prove",
    "external": false
  },
  {
    "id": "audit",
    "label": "Audit Log",
    "route": "audit",
    "also": [],
    "group": "Prove",
    "external": false
  },
  {
    "id": "integrations",
    "label": "Integrations",
    "route": "integrations",
    "also": [],
    "group": "Admin",
    "external": false
  },
  {
    "id": "connections",
    "label": "Connections",
    "route": "connections",
    "also": [],
    "group": "Admin",
    "external": false
  },
  {
    "id": "siem",
    "label": "SIEM Streaming",
    "route": "siem",
    "also": [],
    "group": "Admin",
    "external": false
  },
  {
    "id": "users",
    "label": "Users & Roles",
    "route": "users",
    "also": [],
    "group": "Admin",
    "external": false
  },
  {
    "id": "security",
    "label": "Security Settings",
    "route": "security",
    "also": [],
    "group": "Admin",
    "external": false
  },
  {
    "id": "govrules",
    "label": "Alert Rules",
    "route": "review-rules",
    "also": [],
    "group": "Admin",
    "external": false
  },
  {
    "id": "g360copilot",
    "label": "G360 Copilot",
    "route": "g360-copilot",
    "also": [],
    "group": "Admin",
    "external": false
  },
  {
    "id": "branding",
    "label": "Branding",
    "route": "branding",
    "also": [],
    "group": "Admin",
    "external": false
  },
  {
    "id": "billing",
    "label": "Billing",
    "route": "billing",
    "also": [],
    "group": "Admin",
    "external": false
  },
  {
    "id": "implguide",
    "label": "Implementation Guide",
    "route": "implguide",
    "also": [],
    "group": "Admin",
    "external": true
  },
  {
    "id": "adminguide",
    "label": "Administrator Guide",
    "route": "adminguide",
    "also": [],
    "group": "Admin",
    "external": true
  },
  {
    "id": "help",
    "label": "Help & Support",
    "route": "help",
    "also": [],
    "group": "Admin",
    "external": false
  },
  {
    "id": "account",
    "label": "My Account",
    "route": "account",
    "also": [],
    "group": "Admin",
    "external": false
  }
];

/* Every route a surface answers to, including its other tabs. */
export const SURFACE_BY_ROUTE = new Map(
  SURFACES.flatMap((s) => [s.route, ...s.also].map((r) => [r, s])),
);
